import styled, { css } from 'styled-components';

export const ExerciseProgressContainer = styled.div`
  padding: 5px;
  height: 100%;
  overflow-y: auto;
`;

export const ProgressHeader = styled.label`
  color: ${({ theme }) => theme.header};
  font-size: 1rem;
  font-weight: 600;
`;

export const LevelRow = styled.span`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding-bottom: 0.5rem;
  color: ${({ theme }) => theme.selectionBox.label};
  ${({ isCurrent }) =>
    !isCurrent &&
    css`
      cursor: pointer;
      :hover {
        label {
          font-weight: bold;
        }
      }
    `}
`;

export const LevelCircleContainer = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 26px;
  min-width: 20px;
  min-height: 26px;
`;

const circleDiameter = 20;
export const LevelCircle = styled.i.attrs(({ checked, completed }) => {
  let icon = 'fa-regular fa-circle';
  if (checked && completed) icon = 'fa-solid fa-circle-check';
  else if (completed) icon = 'fa-regular fa-circle-check';
  else if (checked) icon = 'fa-regular fa-circle-dot';
  return {
    className: icon,
  };
})`
  position: relative;
`;

export const ProgressLine = styled.span`
  position: absolute;
  top: ${circleDiameter + 4}px;
  left: ${circleDiameter / 2 - 1}px;
  width: 2px;
  min-width: 2px;
  border-radius: 3px;
  min-height: calc(100% - ${circleDiameter + 4}px);
  background: ${({ theme }) => theme.selectionBox.label};
`;

export const LevelLabel = styled.label`
  cursor: inherit;
  font-size: 0.8rem;
  margin: 4px 4px 4px 4px;
`;

export const HeaderIcon = styled.i.attrs(() => ({
  className: 'fa fa-trophy',
}))`
  font-size: 18px;
  margin-left: 1px;
  margin-right: 4px;
`;
